import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";
import WalletsComponent from "./Components/Wallets";
import SignupComponent from "./Components/Signup";
import SignupCardComponent from "./Components/SignupCard"
import RecoverComponent from "./Components/Forgot";

import ConfirmationComponent from "./Components/ConfirmEmail";
import ConfirmationForgotPasswordComponent from "./Components/ConfirmForwardedEmail";
import TransactionsComponent from "./Components/Transactions";
import WalletsInformationComponent from "./Components/Addresses";
import TransactionsSeeMoreComponent from "./Components/TransactionsImportant";
// import VirtualExchangeComponent2 from './Components/VirtualExchange';
import VirtualExchangeComponent from "./Components/VirtualExchange2.0";
import InvoicesComponent from "./Components/Invoices";
import WhiteList from "./Components/WhiteList";

//E-Commerce
import EcommerceComponent from "./Components/Ecommerce";
import EcommerceOnboarding from "./Components/Ecommerce/Onboarding";
import EcommerceConfig from "./Components/Ecommerce/Config";
import EcommerceThatsit from "./Components/Ecommerce/Thatsit";
import EcommerceOrder from "./Components/Ecommerce/Order";
import EcommerceWallets from "./Components/Ecommerce/Wallets";
import EcommerceCheckout from "./Components/Checkout";
import EcommerceDevices from "./Components/Ecommerce/Devices";
import EcommerceAddDevices from "./Components/Ecommerce/Devices/addDevice";

//Services
import Services from "./Components/Services";

import ReactNotification from "react-notifications-component";

// -- Cambios no lanzados
import FAQ from "./Components/NewWirebit/FAQ";
import NewFaqComponent from "./Components/FAQS";

// -- Cambios no lanzados
import LandingComponentBeta2 from "./Components/Landing";
import Landing from "./Components/Landing2.0";
import LandingCard from "./Components/LandingCard";
import NewLogin from "./Components/NewLogin";
import { ContactComponent } from "./Components/Contact/Contact";

import KycForm from "./Components/KycForm";
import SettingsBeta from "./Components/NewWirebit/Settings";

import CardComponent from "./Components/Card";
import WithdrawalComponent from "./Components/Withdrawal";
import { PrivacyPolicy } from "./Components/PrivacyPolicy/privacyPolicy";

import lang_en from "./translate/en";
import lang_es from "./translate/es";

class MainRouter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // checked: (localStorage.getItem("themeColor") === "true") ? true : false,
      lang_archive: lang_en,
    };
    this.onToggleSwitchChange = this.onToggleSwitchChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      lang_archive: this.getLang(),
    });
  }

  getLang() {
    if (localStorage.getItem("lan") === "en") {
      return lang_en;
    }
    if (localStorage.getItem("lan") === "es") {
      return lang_es;
    }
    return lang_en;
  }

  getLanguage() {
    if (
      (localStorage.getItem("lan") && localStorage.getItem("lan") === "en") ||
      localStorage.getItem("lan") === "es"
    ) {
      window.lan = localStorage.getItem("lan");
      return localStorage.getItem("lan");
    } else {
      window.lan = "es";
      return "es";
    }
  }

  changeLan(lang) {
    localStorage.setItem("lan", lang);
    this.setState({
      lang_archive: this.getLang(),
    });
  }

  onToggleSwitchChange() {
    // const self = this;
    // if (self.state.checked === false) {
    //   self.setState({ checked: true });
    //   localStorage.setItem("themeColor", true);
    // } else {
    //   self.setState({ checked: false });
    //   localStorage.setItem("themeColor", false);
    // }
  }

  render() {
    return (
      <Router>
        <ReactNotification />

        {/* <div className={(localStorage.getItem("themeColor") === "false") ? "dark_mode" : "light_mode"}> */}
        <div>
          {/* {
            <Route
              path="/company/resource/cards"
              exact={true}
              render={(props) => <FAQ data={props} lan={this.getLanguage()} />}
            />
          } */}
          <Route
            path="/cards"
            exact={true}
            render={(props) => <LandingCard data={props} lan={this.getLanguage()} changeLan={(lang) => this.changeLan(lang)}/>}
          />
          <Route
            path="/"
            exact={true}
            render={(props) => {
              if (localStorage.getItem("token")) {
                return (
                  <WalletsComponent
                    data={props}
                    traductions={this.state.lang_archive}
                    onToggleSwitchChange={this.onToggleSwitchChange}
                    checked={this.state.checked}
                  />
                );
              }
              window.location.href = "/login";
              return null;
            }}
          />
          <Route
            path="/l"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <WalletsComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                <LandingComponentBeta2
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                  lan={this.getLanguage()}
                />
              )
            }
          />
          <Route
            path="/login"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <WalletsComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                <NewLogin
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                  lan={this.getLanguage()}
                />
              )
            }
          />

          <Route
            path="/contacto"
            exact={true}
            render={(props) => (
              <ContactComponent
                data={props}
                traductions={this.state.lang_archive}
                onToggleSwitchChange={this.onToggleSwitchChange}
                checked={this.state.checked}
                lan={this.getLanguage()}
              />
            )}
          />
          <Route
            path="/faq"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <WalletsComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                <NewFaqComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                  lan={this.getLanguage()}
                />
              )
            }
          />
          <Route
            path="/privacypolicy"
            exact={true}
            render={(props) => (
              <PrivacyPolicy
                data={props}
                traductions={this.state.lang_archive}
                onToggleSwitchChange={this.onToggleSwitchChange}
                checked={this.state.checked}
                lan={this.getLanguage()}
              />
            )}
          />
          <Route
            path="/register"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <WalletsComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                <SignupComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                  lan={this.getLanguage()}
                />
              )
            }
          />
          <Route
            path="/registerCard"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <WalletsComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                <SignupCardComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                  lan={this.getLanguage()}
                />
              )
            }
          />
          <Route
            path="/register/confirmation"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <WalletsComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                <ConfirmationComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                  lan={this.getLanguage()}
                />
              )
            }
          />
          <Route
            path="/forgotpassword/"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <WalletsComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                <ConfirmationForgotPasswordComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                  lan={this.getLanguage()}
                />
              )
            }
          />
          <Route
            path="/recover"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <WalletsComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                <RecoverComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                  lan={this.getLanguage()}
                />
              )
            }
          />
          <Route
            path="/wallets"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <WalletsComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                  changeLan={this.changeLan}
                />
              ) : (
                (() => { window.location.href = "/login"; return null; })()
              )
            }
          />
          <Route
            path="/wallets/information"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <WalletsInformationComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                (() => { window.location.href = "/login"; return null; })()
              )
            }
          />
          <Route
            path="/transactions"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <TransactionsComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                (() => { window.location.href = "/login"; return null; })()
              )
            }
          />
          <Route
            path="/wallets/information/transactions"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <TransactionsSeeMoreComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                (() => { window.location.href = "/login"; return null; })()
              )
            }
          />
          <Route
            path="/virtualexchange"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <VirtualExchangeComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                (() => { window.location.href = "/login"; return null; })()
              )
            }
          />
          {/* <Route path="/virtualexchange2"                  exact={true} render={(props) => (localStorage.getItem('token')) ? (<VirtualExchangeComponent2     data={props} traductions={this.state.lang_archive} onToggleSwitchChange={this.onToggleSwitchChange} checked={this.state.checked} />)   :   (<Redirect to={{ pathname: "/", }} />)} /> */}
          {/* <Route path="/invoices"                         exact={true} render={(props) => (localStorage.getItem('token')) ? (<InvoicesComponent            data={props} traductions={this.state.lang_archive} onToggleSwitchChange={this.onToggleSwitchChange} checked={this.state.checked} />)   :   (<Redirect to={{ pathname: "/", }} />)} /> */}
          <Route
            path="/card"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <CardComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                (() => { window.location.href = "/login"; return null; })()
              )
            }
          />
          <Route
            path="/withdrawal"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <WithdrawalComponent
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                (() => { window.location.href = "/login"; return null; })()
              )
            }
          />
          <Route
            path="/whitelist"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <WhiteList
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                (() => { window.location.href = "/login"; return null; })()
              )
            }
          />
          <Route
            path="/settings"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <SettingsBeta
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                (() => { window.location.href = "/login"; return null; })()
              )
            }
          />
          <Route
            path="/Kyc"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <KycForm
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                />
              ) : (
                (() => { window.location.href = "/login"; return null; })()
              )
            }
          />
          <Switch>
            <Route
              path="/ecommerce"
              exact={true}
              render={(props) =>
                localStorage.getItem("token") ? (
                  <EcommerceComponent
                    data={props}
                    traductions={this.state.lang_archive}
                    onToggleSwitchChange={this.onToggleSwitchChange}
                    checked={this.state.checked}
                  />
                ) : (
                  (() => { window.location.href = "/login"; return null; })()
                )
              }
            />
            <Route
              path="/ecommerce/create"
              exact={true}
              render={(props) =>
                localStorage.getItem("token") ? (
                  <EcommerceOnboarding
                    data={props}
                    traductions={this.state.lang_archive}
                    onToggleSwitchChange={this.onToggleSwitchChange}
                    checked={this.state.checked}
                  />
                ) : (
                  (() => { window.location.href = "/login"; return null; })()
                )
              }
            />
            <Route
              path="/ecommerce/config"
              exact={true}
              render={(props) =>
                localStorage.getItem("token") ? (
                  <EcommerceConfig
                    data={props}
                    traductions={this.state.lang_archive}
                    onToggleSwitchChange={this.onToggleSwitchChange}
                    checked={this.state.checked}
                  />
                ) : (
                  (() => { window.location.href = "/login"; return null; })()
                )
              }
            />
            <Route
              path="/ecommerce/thatsit"
              exact={true}
              render={(props) =>
                localStorage.getItem("token") ? (
                  <EcommerceThatsit
                    data={props}
                    traductions={this.state.lang_archive}
                    onToggleSwitchChange={this.onToggleSwitchChange}
                    checked={this.state.checked}
                  />
                ) : (
                  (() => { window.location.href = "/login"; return null; })()
                )
              }
            />
            <Route
              path="/ecommerce/wallets"
              exact={true}
              render={(props) =>
                localStorage.getItem("token") ? (
                  <EcommerceWallets
                    data={props}
                    traductions={this.state.lang_archive}
                    onToggleSwitchChange={this.onToggleSwitchChange}
                    checked={this.state.checked}
                  />
                ) : (
                  (() => { window.location.href = "/login"; return null; })()
                )
              }
            />
            <Route
              path="/ecommerce/devices"
              exact={true}
              render={(props) =>
                localStorage.getItem("token") ? (
                  <EcommerceDevices
                    data={props}
                    traductions={this.state.lang_archive}
                    onToggleSwitchChange={this.onToggleSwitchChange}
                    checked={this.state.checked}
                  />
                ) : (
                  (() => { window.location.href = "/login"; return null; })()
                )
              }
            />
            <Route
              path="/ecommerce/devices/add"
              exact={true}
              render={(props) =>
                localStorage.getItem("token") ? (
                  <EcommerceAddDevices
                    data={props}
                    traductions={this.state.lang_archive}
                    onToggleSwitchChange={this.onToggleSwitchChange}
                    checked={this.state.checked}
                  />
                ) : (
                  (() => { window.location.href = "/login"; return null; })()
                )
              }
            />
            <Route
              path="/ecommerce/:id_order"
              exact={true}
              render={(props) =>
                localStorage.getItem("token") ? (
                  <EcommerceOrder
                    data={props}
                    traductions={this.state.lang_archive}
                    onToggleSwitchChange={this.onToggleSwitchChange}
                    checked={this.state.checked}
                    lan={this.getLanguage()}
                  />
                ) : (
                  (() => { window.location.href = "/login"; return null; })()
                )
              }
            />
          </Switch>
          <Route
            path="/services"
            exact={true}
            render={(props) =>
              localStorage.getItem("token") ? (
                <Services
                  data={props}
                  traductions={this.state.lang_archive}
                  onToggleSwitchChange={this.onToggleSwitchChange}
                  checked={this.state.checked}
                  lan={this.getLanguage()}
                />
              ) : (
                (() => { window.location.href = "/login"; return null; })()
              )
            }
          />
          <Route
            path="/checkout"
            exact={true}
            render={(props) => <EcommerceCheckout />}
          />
        </div>
      </Router>
    );
  }
}
export default MainRouter;
